<script setup></script>
<template>
	<div class="quiz-welcome">
		<div class="container">
			<div class="quiz-welcome__container">
				<div class="quiz-welcome__content">
					<div class="quiz-welcome__header">
						<h2 class="quiz-welcome__subtitle">Добро пожаловать в игру</h2>
						<h1 class="quiz-welcome__title title"><slot name="nameGame"></slot></h1>
					</div>
					<div class="quiz-welcome__body">
						<slot name="descGame"></slot>
					</div>
					<div class="quiz-welcome__footer">
						<div class="quiz-welcome__text-block">
							<h3 class="quiz-welcome__info">Как это работает?</h3>
							<slot name="listGame"></slot>
						</div>
						<div class="quiz-welcome__text-block">
							<h3 class="quiz-welcome__info">Что же ждет победителей? Захватывающий приз!</h3>
							<slot name="rulesGame"></slot>
						</div>
						<div class="quiz-welcome__start-bnt">
							<slot name="btnStartGame"></slot>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.quiz-welcome {
	padding: 3.3rem 0 12.5rem;
	@media (max-width: vars.$x480) {
		padding: 3.8rem 0 3.5rem;
	}
	&.--words {
		background-image: url("@/assets/img/games/fillword_bg.webp");
		background-repeat: no-repeat;
		background-position: 102% 18%;
		background-size: 54%;
		@media (max-width: vars.$l) {
			background-position: 102% 50%;
		}
		@media (max-width: vars.$t) {
			background-position: 116% 64%;
		}
		@media (max-width: vars.$xx) {
			background-position: 50% 40%;
			background-size: 100%;
		}
		@media (max-width: vars.$x480) {
			background-position: 94% 33%;
			background-size: 125%;
		}
	}
	&.--emoji {
		background-image: url("@/assets/img/games/emoji_bg.webp");
		background-repeat: no-repeat;
		background-position: 89% -51%;
    	background-size: 30%;
		@media (max-width: vars.$l) {
			background-position: 90% 30%;
		}
		@media (max-width: vars.$t) {
			background-position: 97% 64%;
		}
		@media (max-width: vars.$xx) {
			background-position: 50% 44%;
        	background-size: 48%;
		}
		@media (max-width: vars.$x480) {
			background-position: 52% 35%;
        	background-size: 60%;
		}
	}
}
.quiz-welcome__container {
}
.quiz-welcome__content {
	width: 56%;
	@media (max-width: vars.$t) {
		width: 70%;
	}
	@media (max-width: vars.$xx) {
		width: 100%;
		
	}
}
.quiz-welcome__header {
	margin-bottom: 3rem;
	@media (max-width: vars.$xx) {
		text-align: center;
	}
	@media (max-width: vars.$x480) {
		margin-bottom: 1rem;
		
	}
}
.quiz-welcome__subtitle {
	font-weight: 500;
	font-size: 3.2rem;
	line-height: 120%;
	color: #fff;
	margin-bottom: 0.5rem;
	@media (max-width: vars.$x480) {
		font-size: 2.4rem;
		
	}
}
.quiz-welcome__title {
	font-weight: 700;
	font-size: 7.2rem;
	line-height: 140%;
	text-transform: uppercase;
	color: #fff;
	@media (max-width: vars.$x480) {
		font-size: 4rem;
	}
}
.title {
}
.quiz-welcome__body {
	margin-bottom: 5.2rem;
	@media (max-width: vars.$xx) {
		margin-bottom: 40rem;
	}
	@media (max-width: vars.$x480) {
		margin-bottom: 35rem;
	}
}
.quiz-welcome__footer {
	display: grid;
	gap: 4rem;
	border-radius: var(--border-radius);
	padding: 4.3rem 3.2rem 3.2rem;
	background: #fff;
	@media (max-width: vars.$x480) {
		padding: 3.4rem 2.5rem 3rem;
		gap: 2.3rem;
	}
}
.quiz-welcome__text-block {
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 140%;
	:deep(ul) {
		padding-left: 1rem;
		> li {
			&:not(:last-child) {
				margin-bottom: 0.5rem;
			}
		}
	}
}
.quiz-welcome__info {
	font-weight: 700;
	font-size: 2rem;
	line-height: 140%;
	text-transform: uppercase;
	color: #0c4ca3;
	margin-bottom: 1rem;
}
.quiz-welcome__start-bnt {
	width: 35rem;
	@media (max-width: vars.$x480) {
		width: 100%;
	}
	:deep(.btn) {
		width: 100%;
	}
}
:deep(.quiz__text) {
	font-weight: 400;
	font-size: 2.4rem;
	line-height: 140%;
	color: #fff;
	@media (max-width: vars.$xx) {
		text-align: center;
	}
	@media (max-width: vars.$x480) {
		font-size: 1.6rem;
	}
	&:not(:last-child) {
		margin-bottom: 3.5rem;
		@media (max-width: vars.$x480) {
			margin-bottom: 2rem;
		}
	}
}
</style>
